import { Component, type ReactNode } from 'react';
import { SettlementCard, SettlementFailure } from './SettlementParts';

// `onRetry` is required on purpose: a boundary that cannot refresh its card's read would only re-render the
// same cached body and fall straight back into the failed state.
interface Props { title: string; onRetry: () => unknown; children: ReactNode }

// The backstop behind the response guards in `lib/spaces/home`: those validate the fields a card is known to
// use, this catches whatever they miss. A card that throws while rendering becomes that card's failed state
// instead of the app-level error page, so one bad read can never take the space's landing page down.
// Error boundaries are the one React feature that still requires a class.
export class SpaceCardBoundary extends Component<Props, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError(): { failed: boolean } {
    return { failed: true };
  }

  // Re-rendering alone would throw again on the same cached body, so the read is refreshed first.
  private readonly handleRetry = async () => {
    await Promise.resolve(this.props.onRetry()).catch(() => undefined);
    this.setState({ failed: false });
  };

  render() {
    if (!this.state.failed) return this.props.children;
    return <SettlementCard title={this.props.title}><SettlementFailure message="Não foi possível mostrar este conteúdo." retry={this.handleRetry} /></SettlementCard>;
  }
}
